
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { Card, CardContent, Grid } from '@mui/material';

import {useFechInitManagemenets} from './hooks'
import { ManagementsTable } from './ManagementsTable/ManagementsTable';

const LeasesManagements = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitManagemenets({location, paramsURL})

    return (
        <AllowedAccess permissions={['133_ARRENDAMIENTOS_GESTIONES']} renderAuthFailed={<p>Error</p>}>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Card style={{zIndex:'1'}}>
                        <CardContent>
                            <div className='h4 mt-1 mb-1'> Otras Gestiones</div>
                            <div className="border-bottom border-dark"></div>
                            <div className="pt-4"></div>
                                <ManagementsTable useFetchInit={useFetchInit}/>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </AllowedAccess>
    )
}

export {
    LeasesManagements
}